export default {
  error: {
    returnToHomeButton: "Return to Home Page"
  },
  notFound: {
    returnToHomeButton: "Return to Home Page",
    title: "Error 404",
    subtitle: "Sorry! The page you are looking for cannot be found.",
    description: "You might have entered the URL incorrectly."
  }
};
